import {
  type InferOutput,
  minLength,
  object,
  pipe,
  string,
  trim,
} from "valibot";

export const CreditCardSchema = object({
  nameOnCard: pipe(
    string(),
    trim(),
    minLength(1, "Card holder's name is required"),
  ),
  cardBrand: pipe(string(), minLength(1, "Card brand is required")),
  country: pipe(string(), minLength(1, "Country is required")),
});

export type CreditCardSchemaType = InferOutput<typeof CreditCardSchema>;
